"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _filters = require("./filters");

var _Button = _interopRequireDefault(require("@insided/deprecated-control/ui-components/Button"));

var _Close = _interopRequireDefault(require("@insided/shared/icons/Close"));

var _CardViewV = _interopRequireDefault(require("@insided/destination/icons/CardViewV2"));

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("../utils");

var _Source = _interopRequireDefault(require("@insided/destination/icons/Source"));

var _ProductArea = _interopRequireDefault(require("@insided/destination/icons/ProductArea"));

var _TokenNeutralV = _interopRequireDefault(require("@insided/destination/icons/TokenNeutralV2"));

var _Locale = _interopRequireDefault(require("@insided/destination/icons/Locale"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Sidebar = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Sidebar, _Component);

  var _super = _createSuper(Sidebar);

  function Sidebar() {
    var _this;

    (0, _classCallCheck2.default)(this, Sidebar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      communityCategoryFacetItemsCount: 0,
      knowledgebaseCategoryFacetItemsCount: 0,
      tagsFacetItemsCount: 0,
      contentTypeFacetItemsCount: 0,
      sourceFacetItemsCount: 0,
      productAreaFacetItemsCount: 0,
      zendeskLocaleFacetItemsCount: 0,
      unifiedLocaleFacetItemsCount: 0
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleItemsChange", function (key, itemsCount) {
      _this.setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, (0, _defineProperty2.default)({}, key, itemsCount));
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "shouldShowClearAll", function () {
      var _this$props$searchSta, _this$props$searchSta2, _this$props$searchSta3, _this$props$searchSta4, _this$props$searchSta5, _this$props$searchSta6, _this$props$searchSta7, _this$props$searchSta8, _this$props$searchSta9, _getZendeskLocaleBySe, _this$props$searchSta10, _this$props$searchSta11;

      var isSourceSelected = _this.isSourceFacetEnabled && !!((_this$props$searchSta = _this.props.searchState.refinementList) !== null && _this$props$searchSta !== void 0 && (_this$props$searchSta2 = _this$props$searchSta.source) !== null && _this$props$searchSta2 !== void 0 && _this$props$searchSta2.length);
      var isContentTypeSelected = !!((_this$props$searchSta3 = _this.props.searchState.refinementList) !== null && _this$props$searchSta3 !== void 0 && (_this$props$searchSta4 = _this$props$searchSta3.content_type) !== null && _this$props$searchSta4 !== void 0 && _this$props$searchSta4.length);
      var otherFacetsSelected = !!((_this$props$searchSta5 = _this.props.searchState.refinementList) !== null && _this$props$searchSta5 !== void 0 && (_this$props$searchSta6 = _this$props$searchSta5.tags) !== null && _this$props$searchSta6 !== void 0 && _this$props$searchSta6.length || (_this$props$searchSta7 = _this.props.searchState.hierarchicalMenu) !== null && _this$props$searchSta7 !== void 0 && _this$props$searchSta7['categories.lvl0'] || (_this$props$searchSta8 = _this.props.searchState.hierarchicalMenu) !== null && _this$props$searchSta8 !== void 0 && _this$props$searchSta8['kb.categories.lvl0'] || (_this$props$searchSta9 = _this.props.searchState.hierarchicalMenu) !== null && _this$props$searchSta9 !== void 0 && _this$props$searchSta9['product_area.lvl0'] || (_getZendeskLocaleBySe = (0, _utils.getZendeskLocaleBySearchState)(_this.props.searchState)) !== null && _getZendeskLocaleBySe !== void 0 && _getZendeskLocaleBySe.length || (_this$props$searchSta10 = _this.props.searchState.refinementList) !== null && _this$props$searchSta10 !== void 0 && (_this$props$searchSta11 = _this$props$searchSta10.locale) !== null && _this$props$searchSta11 !== void 0 && _this$props$searchSta11.length);
      return isContentTypeSelected || isSourceSelected || otherFacetsSelected;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "shouldHideFacet", function (key) {
      // For source facet, check isSourceFacetEnabled first
      if (key === 'sourceFacetItemsCount' && !_this.isSourceFacetEnabled) {
        return true;
      } // If options are zero, hide the facet


      if (_this.state[key] === 0) {
        return true;
      } // If there is atleast one option except for zendesk, don't hide the facet


      if (_this.state[key] > 0) {
        if (key === 'zendeskLocaleFacetItemsCount' && _this.state[key] === 1) {
          return true;
        }

        return false;
      } // If there is only one option, check if it's selected


      var _ref = _this.props.searchState.refinementList || {},
          tags = _ref.tags,
          locale = _ref.locale,
          source = _ref.source,
          contentType = _ref.content_type;

      var _ref2 = _this.props.searchState.hierarchicalMenu || {},
          communityCategory = _ref2['categories.lvl0'],
          knowledgebaseCategory = _ref2['kb.categories.lvl0'],
          productArea = _ref2['product_area.lvl0'];

      switch (key) {
        case 'tagsFacetItemsCount':
          return !(tags !== null && tags !== void 0 && tags.length);

        case 'unifiedLocaleFacetItemsCount':
          return !(locale !== null && locale !== void 0 && locale.length);

        case 'sourceFacetItemsCount':
          return !(source !== null && source !== void 0 && source.length);

        case 'contentTypeFacetItemsCount':
          return !(contentType !== null && contentType !== void 0 && contentType.length);

        case 'communityCategoryFacetItemsCount':
          return !(communityCategory !== null && communityCategory !== void 0 && communityCategory.length);

        case 'knowledgebaseCategoryFacetItemsCount':
          return !(knowledgebaseCategory !== null && knowledgebaseCategory !== void 0 && knowledgebaseCategory.length);

        case 'productAreaFacetItemsCount':
          return !(productArea !== null && productArea !== void 0 && productArea.length);

        default:
          return false;
      }
    });
    return _this;
  }

  (0, _createClass2.default)(Sidebar, [{
    key: "isSourceFacetEnabled",
    get: function get() {
      var _this$props$searchSta12, _this$props$searchSta13;

      // show source facet only when in community tab (gs_data_source includes community)
      return !!((_this$props$searchSta12 = this.props.searchState.refinementList) !== null && _this$props$searchSta12 !== void 0 && (_this$props$searchSta13 = _this$props$searchSta12.gs_data_source) !== null && _this$props$searchSta13 !== void 0 && _this$props$searchSta13.includes('community'));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var showClearAll = this.shouldShowClearAll();
      var hideSources = this.shouldHideFacet('sourceFacetItemsCount');
      var hideContentType = this.shouldHideFacet('contentTypeFacetItemsCount');
      var hideCommunityCategory = this.shouldHideFacet('communityCategoryFacetItemsCount');
      var hideProductArea = this.shouldHideFacet('productAreaFacetItemsCount');
      var hideKnowledgebaseCategory = this.shouldHideFacet('knowledgebaseCategoryFacetItemsCount');
      var hideTags = this.shouldHideFacet('tagsFacetItemsCount');
      var hideUnifiedLocale = this.shouldHideFacet('unifiedLocaleFacetItemsCount');
      var hideZendeskLocale = this.shouldHideFacet('zendeskLocaleFacetItemsCount');
      var hideAllFilters = hideContentType && hideCommunityCategory && hideKnowledgebaseCategory && hideTags && hideSources && hideUnifiedLocale && hideZendeskLocale && hideProductArea;
      return (0, _preact.h)("div", {
        hidden: hideAllFilters,
        className: (0, _classnames.default)('instant-search__results-wrapper-filter unified-index', {
          'instant-search__results-wrapper-filter--hide': !this.props.isFiltersOverlay
        })
      }, (0, _preact.h)("div", {
        className: "instant-search__results-wrapper-filter-header"
      }, (0, _preact.h)("div", {
        role: "button",
        tabIndex: 1,
        className: "close-icon",
        onClick: this.props.handleFilterChange
      }, (0, _preact.h)(_Close.default, null)), (0, _preact.h)("h4", {
        className: "instant-search__results-wrapper-filter-header-heading"
      }, (0, _preact.h)(_phrase.default, {
        p: "advanced.search.filters"
      })), (0, _preact.h)("span", {
        className: "instant-search__results-wrapper-filter-header-btn-wrapper"
      }, showClearAll && (0, _preact.h)("button", {
        onClick: this.props.clearAllFilters,
        className: "instant-search__results-wrapper-filter-header-btn"
      }, (0, _preact.h)(_phrase.default, {
        m: "Common",
        p: "advanced.search.filter.clear.all"
      })))), (0, _preact.h)("div", {
        className: "instant-search__results-wrapper-filters"
      }, (0, _preact.h)("div", {
        hidden: hideSources,
        className: "instant-search__results-wrapper-filter-section"
      }, (0, _preact.h)(_filters.Tags, {
        title: (0, _preact.h)(_phrase.default, {
          m: "Common",
          p: "advanced.search.filter.source"
        }),
        icon: (0, _preact.h)(_Source.default, {
          width: 16,
          height: 16
        }),
        operator: "and",
        attribute: "source",
        searchable: true,
        limit: 1000,
        showMore: true,
        onItemsChange: function onItemsChange(count) {
          return _this2.handleItemsChange('sourceFacetItemsCount', count);
        }
      })), (0, _preact.h)("div", {
        hidden: hideContentType,
        className: "instant-search__results-wrapper-filter-section"
      }, (0, _preact.h)(_filters.Tags, {
        title: (0, _preact.h)(_phrase.default, {
          m: "Common",
          p: "advanced.search.filter.topic.type"
        }),
        icon: (0, _preact.h)(_ProductArea.default, {
          width: 16,
          height: 16
        }),
        attribute: "content_type",
        operator: "and",
        searchable: true,
        limit: 1000,
        showMore: true,
        onItemsChange: function onItemsChange(count) {
          return _this2.handleItemsChange('contentTypeFacetItemsCount', count);
        }
      }), (0, _preact.h)("div", {
        className: "divider"
      })), (0, _preact.h)("div", {
        hidden: hideCommunityCategory,
        className: "instant-search__results-wrapper-filter-section"
      }, (0, _preact.h)(_filters.CustomHierarchicalMenu, {
        attributes: ['categories.lvl0', 'categories.lvl1', 'categories.lvl2'],
        title: (0, _preact.h)("span", {
          className: "instant-search__filter-title"
        }, (0, _preact.h)(_CardViewV.default, {
          width: 16,
          height: 16
        }), (0, _preact.h)(_phrase.default, {
          m: "Common",
          p: "advanced.search.filter.community.category"
        })),
        limit: 1000,
        onItemsChange: function onItemsChange(count) {
          return _this2.handleItemsChange('communityCategoryFacetItemsCount', count);
        }
      }), (0, _preact.h)("div", {
        className: "divider"
      })), this.props.isKnowledgeBaseActive && this.props.displayKnowledgeBaseCategories && (0, _preact.h)("div", {
        hidden: hideKnowledgebaseCategory,
        className: "instant-search__results-wrapper-filter-section"
      }, (0, _preact.h)(_filters.CustomHierarchicalMenu, {
        attributes: ['kb.categories.lvl0', 'kb.categories.lvl1', 'kb.categories.lvl2'],
        title: (0, _preact.h)("span", {
          className: "instant-search__filter-title"
        }, (0, _preact.h)(_CardViewV.default, {
          width: 16,
          height: 16
        }), (0, _preact.h)(_phrase.default, {
          m: "Common",
          p: "advanced.search.filter.knowledgebase.category"
        })),
        limit: 1000,
        onItemsChange: function onItemsChange(count) {
          return _this2.handleItemsChange('knowledgebaseCategoryFacetItemsCount', count);
        }
      }), (0, _preact.h)("div", {
        className: "divider"
      })), (0, _preact.h)("div", {
        hidden: hideProductArea,
        className: "instant-search__results-wrapper-filter-section"
      }, (0, _preact.h)(_filters.CustomHierarchicalMenu, {
        attributes: ['product_area.lvl0', 'product_area.lvl1'],
        title: (0, _preact.h)("span", {
          className: "instant-search__filter-title"
        }, (0, _preact.h)(_CardViewV.default, {
          width: 16,
          height: 16
        }), (0, _preact.h)(_phrase.default, {
          m: "Common",
          p: "advanced.search.filter.product.area"
        })),
        limit: 1000,
        onItemsChange: function onItemsChange(count) {
          return _this2.handleItemsChange('productAreaFacetItemsCount', count);
        }
      }), (0, _preact.h)("div", {
        className: "divider"
      })), (0, _preact.h)("div", {
        hidden: hideTags,
        className: "instant-search__results-wrapper-filter-section"
      }, (0, _preact.h)(_filters.Tags, {
        title: (0, _preact.h)(_phrase.default, {
          m: "Common",
          p: "advanced.search.filter.tag"
        }),
        icon: (0, _preact.h)(_TokenNeutralV.default, {
          width: 16,
          height: 16
        }),
        operator: "and",
        attribute: "tags",
        searchable: true,
        limit: 1000,
        showMore: true,
        onItemsChange: function onItemsChange(count) {
          return _this2.handleItemsChange('tagsFacetItemsCount', count);
        }
      })), this.props.selectedSource === 'zendesk' && (0, _preact.h)("div", {
        hidden: hideUnifiedLocale,
        className: "instant-search__results-wrapper-filter-section"
      }, (0, _preact.h)(_filters.Tags, {
        title: (0, _preact.h)(_phrase.default, {
          m: "Common",
          p: "locale"
        }),
        icon: (0, _preact.h)(_Locale.default, {
          width: 16,
          height: 16
        }),
        phrasePrefix: "locale",
        operator: "and",
        attribute: "locale",
        limit: 1000,
        showMore: true,
        onItemsChange: function onItemsChange(count) {
          return _this2.handleItemsChange('unifiedLocaleFacetItemsCount', count);
        }
      }))), this.props.isFiltersOverlay && (0, _preact.h)("div", {
        className: "instant-search__results-wrapper-filter-show-more-wrapper"
      }, (0, _preact.h)(_Button.default, {
        cta: true,
        className: "instant-search__results-wrapper-filter-show-more",
        onClick: this.props.handleFilterChange
      }, (0, _preact.h)(_phrase.default, {
        m: "Forum",
        p: "advanced.search.show.more.topics",
        count: {
          number: this.props.totalAmount.totalTopics.toString()
        }
      }))));
    }
  }]);
  return Sidebar;
}(_preact.Component);

exports.default = Sidebar;